import { useForm } from "react-hook-form";
import { baseURL } from '../config/config';
import { post } from "../utils/apiManager";
import { toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import { useState } from "react";

const ForgotPassword = () => {
  const { register, handleSubmit, formState: { errors } } = useForm();
  const Navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const onSubmit = (data) => {
    setLoading(true);
    post(`${baseURL}/admin/forgot-password`, data).then((res) => {
      setLoading(false);
      if (res?.status) { toast.success(res.message); Navigate(`/auth/reset-password/${res.validateSting}`); }
      else toast.error(res?.message);
    }).catch((err) => { setLoading(false); toast.error(err?.response?.data?.error); });
  };

  return (
    <div style={{ width: '100%', maxWidth: 420, fontFamily: "'Segoe UI', system-ui, sans-serif" }}>
      <div style={{ background: '#fff', borderRadius: 16, boxShadow: '0 8px 32px rgba(26,39,68,.12)', overflow: 'hidden', padding: '40px 36px' }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div style={{ width: 52, height: 52, borderRadius: 14, background: '#fee2e2', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 24, margin: '0 auto 14px' }}>🔒</div>
          <h2 style={{ fontSize: 22, fontWeight: 700, color: '#0a1628', margin: '0 0 6px', letterSpacing: '-0.5px' }}>Forgot Password</h2>
          <p style={{ fontSize: 14, color: '#9aa5c0', margin: 0 }}>Enter your email and we'll send a reset link</p>
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div style={{ marginBottom: 20 }}>
            <label style={{ fontSize: 13, fontWeight: 600, color: '#3a4a6a', marginBottom: 6, display: 'block' }}>Email Address</label>
            <input placeholder="admin@example.com" type="email"
              style={{ width: '100%', padding: '11px 14px', borderRadius: 9, border: `1.5px solid ${errors.email ? '#AD2429' : '#e2e8f0'}`, fontSize: 14, color: '#0a1628', outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit' }}
              {...register("email", { required: true })} />
            {errors.email && <span style={{ fontSize: 12, color: '#AD2429', marginTop: 4, display: 'block' }}>Email is required</span>}
          </div>
          <button type="submit" disabled={loading} style={{ width: '100%', padding: '12px', background: '#AD2429', color: '#fff', border: 'none', borderRadius: 9, fontSize: 15, fontWeight: 700, cursor: loading ? 'not-allowed' : 'pointer', fontFamily: 'inherit', opacity: loading ? 0.7 : 1, marginBottom: 16 }}>
            {loading ? 'Sending...' : 'Send Reset Link'}
          </button>
          <div style={{ textAlign: 'center' }}>
            <a href="/auth/login" style={{ fontSize: 13, color: '#9aa5c0', textDecoration: 'none' }}>← Back to Login</a>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
